import { Component, inject, input } from '@angular/core';
import { DetailViewDto, PackageDto, TransportTrafficLightRuleConfig } from '@myarvato/modules/transport/models';
import { TrafficLightBubbleComponent } from '@myarvato/shared/traffic-light-bubble';
import { TrackingDetailsStore } from '@myarvato/modules/transport/services';

@Component({
  selector: 'transport-detail-sidebar-quickselect',
  imports: [TrafficLightBubbleComponent],
  templateUrl: './details-sidebar-quickselect.component.html',
  styleUrl: './details-sidebar-quickselect.component.scss',
})
export class DetailsSidebarQuickselectComponent {
  // injections
  private readonly detailStore = inject(TrackingDetailsStore);

  // inputs
  public readonly details = input.required<DetailViewDto>();

  // fields
  protected readonly bubbleRules = TransportTrafficLightRuleConfig;

  protected onSelectionChanged(packageDto: PackageDto | undefined): void {
    if (packageDto == null) {
      return;
    }

    this.detailStore.setSelectedItem({ ehGuid: packageDto.id, trackingNumber: packageDto.trackingNumber });
  }

  protected onKeyUp(event: KeyboardEvent, packageDto: PackageDto | undefined): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.onSelectionChanged(packageDto);
    }
  }
}
